import { render, staticRenderFns } from "./testimonialComponent.vue?vue&type=template&id=afd6562e&scoped=true&"
import script from "./testimonialComponent.vue?vue&type=script&lang=js&"
export * from "./testimonialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6562e",
  null
  
)

export default component.exports